import { render, staticRenderFns } from "./Ztjz.vue?vue&type=template&id=b051382e&scoped=true&"
import script from "./Ztjz.vue?vue&type=script&lang=js&"
export * from "./Ztjz.vue?vue&type=script&lang=js&"
import style0 from "./Ztjz.vue?vue&type=style&index=0&id=b051382e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b051382e",
  null
  
)

export default component.exports